import React, { Component } from 'react';
import _ from 'lodash';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';

import { m } from '../../utils';
import './payments.css';

class StatementsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: [0, 0],
    };
  }

  render() {
    const { payments, selectPayment } = this.props;
    const grouped = _.toPairs(
      _.groupBy(payments, payment => m(payment.period.replace(/\s.*/, ''), 'YYYY-MM-DD').format('MMMM YYYY'))
    );

    const { selectedIndex } = this.state;
    const selected1 = selectedIndex[0];
    const selected2 = selectedIndex[1];

    return (
      <div className="payments__statements-container">
        {grouped.map((month, index1) => (
          <div className="payments__statements-container--month">
            <div className="payments__statements-container--title"> {month[0]}</div>
            <div className="payments__statements-container--month-payments">
              {' '}
              {month[1].map((payment, index2) => (
                <div
                  className={`payments__statements-container--payment ${
                    selected1 === index1 && selected2 === index2 ? 'payments__selected' : ''
                  }`}
                  onClick={() => {
                    selectPayment(payment);
                    this.setState({ selectedIndex: [index1, index2] });
                  }}>
                  {' '}
                  <div className="payments__statements-container--payment--dates">
                    <div className="payments__statements-container--payment--period">{`${m(
                      payment.period.replace(/\s.*/i, ''),
                      'YYYY-MM-DD'
                    ).format('Do')} to ${m(payment.period.split('..')[1].replace(/\s.*/i, ''), 'YYYY-MM-DD').format(
                      'Do'
                    )}`}</div>
                    <div className="payments__statements-container--payment--due">
                      {payment.payout > 0
                        ? `Pay Day: ${m(payment.period.replace(/\s.*/i, ''), 'YYYY-MM-DD')
                            .add(2, 'week')
                            .add(2, 'day')
                            .format('MMM Do')}`
                        : '-'}
                    </div>
                  </div>
                  <div
                    className={`payments__statements-container--payment-total ${
                      (payment.payout !== 0 ? payment.payout.toFixed(2) : payment.balance.toFixed(2)) < 0
                        ? 'red'
                        : ''
                    }`}>
                    {' '}
                    {`$${
                      payment.payout !== 0 ? payment.payout.toFixed(2) : payment.balance.toFixed(2)
                    }`}{' '}
                  </div>
                  <FontAwesomeIcon className="payments__statements-container--icon" icon={faChevronRight} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default StatementsContainer;



// WEBPACK FOOTER //
// ./src/components/NewPayments/StatementsContainer.js